import request from '@/utils/request'
import { encrypt } from '@/utils/jsencrypt'

// 登录方法
export function login (data) {
  if(data.pwd){
    data.pwd = encrypt(data.pwd)
  }
  return request({
    url: '/business/user/login',
    method: 'post',
    data
  })
}
// 退出方法
export function logout () {
  return request({
    url: '/business/user/logout',
    method: 'post'
  })
}

// 发送短信
export function sendCode (phone, type, systemType) {
  return request({
    url: '/business/user/sendCode/' + phone + '/' + type + '/' + systemType,
    method: 'post'
  })
}

//获取用户是否被禁用
export function getUserDisable (systemType) {
  return request({
    url: '/business/user/getUserDisable' + '/' + systemType,
    method: 'get'
  })
}

export function getSupplierDisable (systemType, userType) {
  return request({
    url: '/business/user/getSupplierDisable' + '/' + systemType + '/' + userType,
    method: 'get'
  })
}

//获取用户信息
export function getUserInfo (systemType) {
  return request({
    url: '/business/user/getUserInfo' + '/' + systemType,
    method: 'get'
  })
}

// 注册方法（林业竞拍、物流招标使用）
export function register (data) {
  if(data.password){
    data.password = encrypt(data.password)
  }
  return request({
    url: '/business/user/register',
    method: 'post',
    data
  })
}

// 校验手机号是否在库
export function checkPhoneExists (phone, systemType, userType) {
  return request({
    url: '/business/user/checkPhoneExists/' + phone + '/' + systemType + '/' + userType,
    method: 'get'
  })
}

// 校验企业名称/个人姓名是否在库
export function checkEnterpriseNameOrPersonName (query) {
  return request({
    url: '/business/register/checkEnterpriseNameOrPersonName',
    method: 'get',
    params: query
  })
}

// 注册方法（采购招标）
export function registerUser (data) {
  if(data.password){
    data.password = encrypt(data.password)
  }
  return request({
    url: '/business/register/register',
    method: 'post',
    data
  })
}

// 简易注册方法（采购招标）
export function simpleRegisterUser (data) {
  if(data.password){
    data.password = encrypt(data.password)
  }
  return request({
    url: '/business/register/simpleRegister',
    method: 'post',
    data
  })
}


export function updateUserPwd (data) {
  if(data.password){
    data.password = encrypt(data.password)
  }
  return request({
    url: '/business/user/updatePwd',
    method: 'post',
    data
  })
}


